import { css } from 'emotion';

export const popoverBodyStyles = css`
  padding: 8px;
  font-size: 13px;
  max-width: 350px;
`;

export const popoverTipShapeStylesBelow = css`
  fill: #ffffff;
  stroke: rgb(223, 227, 232);
  stroke-width: 1px;
`;
